// Last-crumb label for entity pages (firm, deal, result). Set by the page that loaded the name.
import { create } from 'zustand';

interface CrumbEntityState {
  path: string | null;
  label: string | null;
  setEntity: (path: string, label: string | null) => void;
}

export const useCrumbEntityStore = create<CrumbEntityState>((set) => ({
  path: null,
  label: null,
  setEntity: (path, label) =>
    set((state) => {
      const next = label?.trim() || null;
      if (next) return { path, label: next };
      if (state.path === path) return { path: null, label: null };
      return state;
    }),
}));
